import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import officeMain from '../views/mainMenu/officeMain.vue'
import error from '../views/error/error.vue'
import dashbTasks from '../views/officeMain/tasks/dashbTasks.vue'
import esPlanningMain from '../views/planningMain/esPlanningMain.vue'
import dashbAccounting from '../views/officeMain/accounting/dashbAccounting.vue'
import dashbInstituteSettings from '../views/officeMain/settings/dashbInstituteSettings.vue'
import Login from "../views/Login.vue"
import NotFound from "../views/NotFound.vue"
import SessionStorageService from "@/services/SessionStorageService";
import esPatientMain from "@/views/patientMain/esPatientMain.vue";
import esAdmin from "@/views/admin/esAdmin.vue";
import { Permissions, PermissionsAdmin } from "@/models/permissions.model";
import { usePermissionsStore } from '@/stores/permissionsStore';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'home',
    redirect: 'calendar',
    component: officeMain,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: 'calendar',
        name: 'calendar',
        component: esPlanningMain,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.planning.ACCESS_PLANNING.name
        }
      },
      //Tasks
      {
        path: 'tasks',
        name: 'tasks',
        component: dashbTasks,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.task.ACCESS_TASK.name
        }
      },
      //Accounting
      {
        path: 'accounting/income',
        name: 'income',
        component: dashbAccounting,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.accounting.ACCESS_ACCOUNTING.name
        }
      },
      {
        path: 'accounting/expenses',
        name: 'expenses',
        component: dashbAccounting,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.accounting.ACCESS_ACCOUNTING.name
        }
      },
      //Admin
      {
        path: 'admin',
        name: 'admin',
        component: esAdmin,
        meta: {
          requiresAuth: true,
          permissionName: PermissionsAdmin.esklepios.ADMIN_ESKLEPIOS
        }
      },
      {
        path: 'settings/institutesettings',
        name: 'institutesettings',
        component: dashbInstituteSettings,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.admin.ADMIN_INSTITUTE.name
        }
      },
      {
        path: '/patient/:patientId',
        name: 'patient',
        component: esPatientMain,
        meta: {
          requiresAuth: true,
          permissionName: Permissions.patient.READ_PATIENT_DATA.name
        }
      },
      {
        path: '/error',
        name: 'error',
        component: error,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes
})

router.resolve({
  name: 'not-found',
  params: { pathMatch: ['not', 'found'] },
}).href

router.beforeEach(async (to, from, next) => {
  const idToken = SessionStorageService.getItem("idToken");

  if (to.matched.some(route => route.meta.requiresAuth) && !idToken) {
      next({ path: '/login' });
  } else {
      const allowed =  to.meta?.permissionName ? await usePermissionsStore().checkPermission(to.meta?.permissionName as string) : true;
      if (to.matched.some(route => route.meta.guest) && idToken) {
          allowed ? next('/') : next("/error?error=USER_WITHOUT_AVAILABLE_MODULE");
      } else {
          allowed ? next() : next("/error?error=USER_WITHOUT_AVAILABLE_MODULE");
      }
  }
});


export default router
